import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface ErrorMessageProps {
  message?: string;
  retry?: () => void;
  className?: string;
  ariaLabel?: string;
}

export function ErrorMessage({ message = 'Wystąpił błąd. Spróbuj ponownie.', retry, className, ariaLabel }: ErrorMessageProps) {
  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-label={ariaLabel || 'Wystąpił błąd ładowania zawartości'}
      className={className}
    >
      <div className="text-center py-12 bg-white dark:bg-accessible-gray-800 high-contrast:bg-black rounded-lg shadow-lg">
        <div className="flex justify-center items-center gap-3 mb-4">
          <AlertTriangle className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
          <p className="text-xl text-accessible-red-600">{message}</p>
        </div>
        {retry && (
          <button
            onClick={retry}
            className="inline-flex items-center gap-2 px-6 py-3 bg-accessible-red-600 hover:bg-accessible-red-700 text-white rounded-lg transition-colors"
            aria-label="Spróbuj ponownie załadować zawartość"
          >
            Spróbuj ponownie
          </button>
        )}
      </div>
    </div>
  );
}

export default ErrorMessage;


